<template>
    <v-list three-line ref="list" class="nx-primary--lighten-5">
      <div class="nx-sortable-item" v-for="(item, index) in value" :key="item.type + item.id">
        <nx-searcher-sortable-list-item v-bind="item"
                                        @delete="onDelete(item)"
                                        ></nx-searcher-sortable-list-item>
        <v-divider class="nx-sortable-ignore" v-if="index + 1 < value.length" :key="index"></v-divider>
      </div>
    </v-list>
</template>

<script>
import Sortable from 'sortablejs';
import ListItem from './SortableListItem';

export default {
  components: {
    [ListItem.name]: ListItem,
  },
  name: 'nx-searcher-sortable-list',
  data() {
    return {
      sortable: null,
    };
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.sortable = Sortable.create(this.$refs.list.$el, {
      handle: '.nx-sortable-handle',
      draggable: '.nx-sortable-item',
      onUpdate: event => this.$emit('sortable', event),
    });
  },
  methods: {
    onDelete(item) {
      this.$emit('delete', item);
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-sortable-handle {
  cursor: move;
}
.sortable-ghost {
  opacity: 0;
}
</style>
